<div class="panel rs-bg-grey1">
  <h3 class="rs-tit6 rs-txt-c1">
    {{ 'bizz.guest.wifi.ssid.label' | translate }}
  </h3>
  <div class="row">
    <div class="small-12 medium-6 columns">
      <div class="rs-form-item" [ngClass]="{ error: isSsidUnavailable }">
        <input
          type="text"
          id="ac-input1"
          [(ngModel)]="ssid"
          #newSsidInput="ngModel"
          maxlength="20"
          (ngModelChange)="validateSsid()"
          [ngClass]="{ 'rs-filled': !isSsidEmpty() }"
          [attr.disabled]="isSsidUnavailable ? '' : null"
        />
        <label class="rs-form-label" for="ac-input1">{{ bizzGuestWifiSsid }}</label>
        <div class="rs-form-helper" id="ac-helper-pwd1">
          <span id="ac-error1">{{ 'bizz.guest.wifi.ssid.length' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
    <div class="rs-flex-columns">
      <button
        type="submit"
        class="rs-btn"
        [disabled]="!isSsidValid"
        [ngClass]="{ 'rs-btn-disabled': !isSsidValid }"
        (click)="updateBizzGuestWifiSsid()"
      >
        {{ 'bizz.guest.wifi.ssid.button.save' | translate }}
      </button>
      <px-alert [alertKey]="'updateBizzGuestWifiSsidAlert'"></px-alert>
    </div>
  </div>
</div>
